import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import React from 'react';
import type { SecuredComponentBaseProps } from '../../types';
import { useSecurity } from '../hooks/useSecurity';

type SecuredIconButtonProps = Omit<IconButtonProps, 'disabled'> &
    SecuredComponentBaseProps & {
        disabled?: boolean;
    };

export default function SecuredIconButton({
    securityAction,
    securityTarget,
    securityEnforcementMode = 'hidden',
    fallback = null,
    disabled,
    ...iconButtonProps
}: SecuredIconButtonProps) {
    const decision = useSecurity(securityAction, securityTarget);
    const isAllowed = !decision.pending && decision.allowed;

    if (!isAllowed && securityEnforcementMode === 'hidden') {
        return fallback;
    }

    const isSecurelyDisabled = !isAllowed || Boolean(disabled);

    return <IconButton {...iconButtonProps} disabled={isSecurelyDisabled} />;
}
